<template>
  <div class="popup-overlay">
      <div class="popup">
      <button type="button" class="close-btn" v-on:click="close(false)">
        <i class="fa fa-close"></i>
      </button>
      <h1>Fellebbezés</h1>
      <div class="info-box warning">
        Figyelem! Fellebbezését csak egyszer nyújthatja be.
      </div>

      <textareabox cstyle="height: 200px; width: 400px;" :autogrow="true" maxlength="2000" id="msg" label="Üzenet" :errors="errors" name="msg" v-model="msg"></textareabox>

      <div class="form-group last">
        <button v-on:click="send" type="button" class="button v2">Beküld</button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    form_id: {
      type: [Number, String],
      required: true
    }
  },
  data: function () {
    return {
      msg: '',
      errors: []
    }
  },
  computed: {

  },
  methods: {
    close: function(final) {
      this.$emit('close', final);
    },

    send: function() {
      var _this = this;
      this.errors = [];

      this.$root.ajax('fellebezes/', {
        data: {
          form_id: this.form_id,
          msg: this.msg
        },
        method: 'POST',
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            swal('Siker!', 'Sikeresen beküldte fellebezését.', 'success');
            _this.close(true);
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// fellebezes.vue?5f98eea0